module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/panel_git_metas.json
// module id = 2522
// module chunks = 47